
  var _styles = {
  "three-card-container": {
    "width": "3.01333rem",
    "height": "4.76rem",
    "borderRadius": "0.24rem",
    "marginTop": "0.16rem",
    "backgroundColor": "rgb(255,255,255)"
  },
  "three-card-image-view": {
    "borderRadius": "0.24rem 0.24rem 0 0",
    "width": "3.01333rem",
    "height": "2.26667rem",
    "overflow": "hidden",
    "marginBottom": "0.05333rem",
    "position": "relative"
  },
  "three-card-custom-tag-view": {
    "width": "1.38667rem",
    "height": "0.42667rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center",
    "position": "absolute",
    "left": 0,
    "top": 0,
    "zIndex": 9,
    "borderRadius": "0.24rem 0 0.24rem 0"
  },
  "three-card-custom-tag-bg": {
    "width": "1.38667rem",
    "height": "0.42667rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "three-card-custom-tag-text": {
    "fontSize": "0.26667rem",
    "lineHeight": "0.42667rem",
    "color": "rgb(255,255,255)",
    "textAlign": "center"
  },
  "three-card-deal-title-view": {
    "marginTop": 0,
    "marginRight": "0.16rem",
    "marginBottom": 0,
    "marginLeft": "0.16rem",
    "height": "0.8rem"
  },
  "three-card-deal-title": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "color": "rgb(34,34,34)",
    "lineHeight": "0.4rem",
    "fontWeight": "500"
  },
  "three-card-image": {
    "width": "3.01333rem",
    "height": "2.32rem",
    "borderRadius": "0.24rem 0.24rem 0 0",
    "overflow": "hidden"
  },
  "three-card-image-shadow": {
    "position": "absolute",
    "opacity": 0.6,
    "width": "3.01333rem",
    "height": "0.64rem",
    "bottom": 0
  },
  "three-card-pos": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "position": "absolute",
    "bottom": "0.10667rem",
    "left": "0.10667rem",
    "height": "0.32rem",
    "padding": "0.02667rem"
  },
  "three-card-pos-icon": {
    "width": "0.18667rem",
    "height": "0.21333rem",
    "marginBottom": "0.02667rem",
    "marginRight": "0.10667rem"
  },
  "three-card-pos-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.32rem",
    "fontWeight": "500"
  },
  "three-card-tag-field": {
    "paddingTop": "0.16rem",
    "paddingRight": "0.16rem",
    "paddingBottom": 0,
    "paddingLeft": "0.16rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "height": "0.53333rem"
  },
  "three-card-discount-tag": {
    "borderRadius": "0.21333rem 0.21333rem 0.21333rem 0.02667rem",
    "paddingTop": "0.02667rem",
    "paddingRight": "0.08rem",
    "paddingBottom": "0.02667rem",
    "paddingLeft": "0.08rem",
    "marginRight": "0.08rem"
  },
  "three-card-discount-text": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.37333rem",
    "fontWeight": "600"
  },
  "three-card-sale-tag": {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "borderRadius": "0.08rem",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderColor": "rgb(255,226,188)",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "marginRight": "0.08rem",
    "height": "0.37333rem"
  },
  "three-card-sale-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "color": "rgb(255,75,16)",
    "fontWeight": "400"
  },
  "three-card-sale-tag-image": {
    "height": "0.37333rem",
    "marginRight": "0.08rem"
  },
  "three-card-bottom-field": {
    "padding": "0.16rem",
    "width": "100%"
  },
  "three-card-bottom-field-container": {
    "width": "100%",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "three-card-price-field": {
    "height": "0.8rem",
    "display": "flex",
    "justifyContent": "flex-end"
  },
  "three-card-price": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "flex-end"
  },
  "three-card-price-sale-price": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "flex-end",
    "height": "0.53333rem"
  },
  "three-card-price-unit": {
    "color": "rgb(255,75,16)",
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "700",
    "fontSize": "0.32rem",
    "textAlign": "left",
    "lineHeight": "0.53333rem",
    "marginTop": "0.02667rem"
  },
  "three-card-price-number": {
    "color": "rgb(255,75,16)",
    "fontFamily": "MTNewDigitalDisplay-Bold",
    "fontWeight": "700",
    "fontSize": "0.26667rem",
    "lineHeight": "0.53333rem",
    "textAlign": "left",
    "marginTop": "0.10667rem"
  },
  "three-card-price-icon": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.32rem",
    "color": "rgb(255,75,16)",
    "lineHeight": "0.32rem",
    "fontWeight": "500",
    "marginBottom": "0.04rem"
  },
  "three-card-price-value": {
    "fontFamily": "MTfin-Regular2_0",
    "fontSize": "0.56rem",
    "color": "rgb(255,75,16)",
    "lineHeight": "0.56rem",
    "fontWeight": "700"
  },
  "three-card-price-start": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(136,136,136)",
    "lineHeight": "0.4rem",
    "fontWeight": "400"
  },
  "three-card-origin-price-content": {
    "height": "0.32rem"
  },
  "three-card-origin-price": {
    "fontWeight": "400",
    "color": "rgb(136,136,136)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.32rem",
    "textAlign": "left",
    "textDecoration": "line-through"
  },
  "three-card-btn-container": {
    "height": "0.8rem",
    "display": "flex",
    "justifyContent": "flex-end",
    "alignItems": "flex-end"
  },
  "three-card-btn": {
    "width": "1.12rem",
    "borderRadius": "0.4rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.64rem"
  },
  "three-card-btn-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.42667rem",
    "fontWeight": "600"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTfin-Regular2_0', 'url("https://s3plus.meituan.net/v1/mss_098f084b61e744a0ae960d755eaad45e/meishi-yingxiao/fonts/max-icon/MTfin-Regular2.0.ttf")');
    document.fonts.add(fontFace0);
    
    var fontFace1 = new FontFace('MTNewDigitalDisplay-Regular', 'url("https://s3plus.meituan.net/s3plus-specialgroup-hfe/fonts/MTNewDigitalDisplay-Regular.otf") format("opentype")');
    document.fonts.add(fontFace1);
    
    var fontFace2 = new FontFace('MTNewDigitalDisplay-Bold', 'url("https://s3plus.meituan.net/s3plus-specialgroup-hfe/fonts/MTNewDigitalDisplay-Bold.otf") format("opentype")');
    document.fonts.add(fontFace2);
    
  }
    


  module.exports = _styles;
  